<template>
  <FloatingButtonContainer>
    <div
      v-if="isLoggedIn"
      class="pointer-events-none flex flex-row items-center"
    >
      <div class="pin-slider-container">
        <div
          class="flex flex-col items-end pin-color-picker bg-white bg-opacity-50"
          :class="{ 'picker-slide-in': showPicker }"
        >
          <div class="flex flex-row">
            <button class="end-pin-button pointer-events-auto">
              <icon-pen :colorLabel="selectedColor" />
            </button>
            <div>
              <button
                class="pin-btn pointer-events-auto"
                @click="selectNeutral"
              >
                <div
                  class="pin bg-interaction-dark"
                  :class="{
                    selected: selectedColor == colorOptions.NEUTRAL && showPins
                  }"
                ></div>
              </button>
            </div>
            <div>
              <button class="pin-btn pointer-events-auto" @click="selectBad">
                <div
                  class="pin bg-color-bad"
                  :class="{
                    selected: selectedColor == colorOptions.BAD && showPins
                  }"
                ></div>
              </button>
            </div>
            <div>
              <button class="pin-btn pointer-events-auto" @click="selectGood">
                <div
                  class="pin bg-color-accept"
                  :class="{
                    selected: selectedColor == colorOptions.GOOD && showPins
                  }"
                ></div>
              </button>
            </div>
          </div>
          <div
            class="border-bar"
            :style="{
              backgroundColor: lineColor
            }"
          ></div>
        </div>
      </div>
      <div v-show="showClose">
        <button
          class="pin-close-btn pointer-events-auto text-interaction-dark"
          @click="closePinButton"
        >
          <icon-reject />
        </button>
      </div>
      <div class="flex flex-row">
        <button
          class="pin-button pointer-events-auto inline-block relative"
          @click="toggleColorPicker"
        >
          <icon-pin-circle :colorLabel="selectedColor" />
        </button>
      </div>
    </div>
  </FloatingButtonContainer>
</template>

<script>
import IconPinCircle from "@/components/icons/IconPinCircle.vue";
import IconPen from "@/components/icons/IconPen.vue";
import IconReject from "@/components/icons/IconReject.vue";
import { Pinning } from "@/utils/Pinning";
import constants from "@/constants";
import { mapGetters } from "vuex";
import FloatingButtonContainer from "./FloatingButtonContainer.vue";

export default {
  name: "SelectPinButton",
  components: { IconPinCircle, IconPen, IconReject, FloatingButtonContainer },
  mixins: [Pinning],
  data() {
    return {
      showPicker: false,
      showClose: false,
      selectedColor: ""
    };
  },
  computed: {
    ...mapGetters("notes", ["showPins"]),
    ...mapGetters("user", ["isLoggedIn"]),
    lineColor() {
      return this.getPinPickerColor(this.selectedColor);
    },
    colorOptions() {
      return {
        GOOD: constants.COLOR_GOOD,
        BAD: constants.COLOR_BAD,
        NEUTRAL: constants.COLOR_NEUTRAL
      };
    }
  },
  methods: {
    toggleColorPicker() {
      this.showPicker = !this.showPicker;
      if (this.showPicker) {
        this.showClose = false;
      } else {
        setTimeout(() => {
          this.showClose = this.selectedColor != "";
        }, 500);
      }
    },
    closeColorPicker() {
      this.showPicker = false;
    },
    closePinButton() {
      this.showClose = false;
      this.$store.commit("notes/disablePinning");
      this.selectedColor = "";
      this.$store.commit("notes/selectColor", this.selectedColor);
    },
    selectGood() {
      this.selectedColor = constants.COLOR_GOOD;
      this.enablePinning();
    },
    selectBad() {
      this.selectedColor = constants.COLOR_BAD;
      this.enablePinning();
    },
    selectNeutral() {
      this.selectedColor = constants.COLOR_NEUTRAL;
      this.enablePinning();
    },
    enablePinning() {
      this.$store.commit("notes/selectColor", this.selectedColor);
      this.$store.commit("notes/enablePinning");
      this.closeColorPicker();
      setTimeout(() => {
        this.showClose = true;
      }, 500);
    }
  }
};
</script>

<style scoped>
.pin-button {
  width: 5.5rem;
  z-index: 2;
}

.pin-color-picker {
  position: relative;
  border-radius: 1rem;
  height: 3rem;
  width: 17rem;
  right: -22.5rem;
  padding-right: 2rem;
  transition: 1s;
}

.picker-slide-in {
  transition: 1s;
  right: -2rem;
}

.pin-color-picker .pin {
  height: 1.5rem;
  width: 1.5rem;
  margin-top: 0.65rem;
  border-radius: 50%;
  cursor: pointer;
  border: solid 0.15rem white;
  position: relative;
  -webkit-box-shadow: 0 0 0.1875rem 0.125rem rgb(165, 150, 150);
  -moz-box-shadow: 0 0 0.1875rem 0.125rem rgb(165, 150, 150);
  box-shadow: 0 0 0.125rem 0.125rem rgb(219, 213, 213);
  transition: 0.25s;
  -webkit-transition-duration: 0.25s;
  -webkit-transition-property: all;
  -webkit-transition-timing-function: ease-in-out;
}

.pin-btn {
  width: 3.5rem;
}

.pin-color-picker .selected {
  height: 2rem;
  width: 2rem;
  margin-top: 0.5rem;
}

.pin-close-btn {
  padding-right: 0.75rem;
  margin-top: 0.65rem;
  border-radius: 50%;
  cursor: pointer;
}

.pin-close-btn svg {
  height: 2.1875rem;
  width: 2.1875rem;
  border: solid 0.15rem white;
  border-radius: 50%;
  background-color: white;
}

.border-bar {
  position: relative;
  height: 0.2rem;
  width: 17rem;
  right: -2rem;
  margin-top: -1.2rem;
}

.end-pin-button {
  position: relative;
  width: 3.97rem;
  margin-right: 2rem;
  margin-top: -0.5rem;
}

.hide-picker {
  width: 2rem;
  margin-left: -1rem;
}

.picker-bar {
  width: 2.4375rem;
  height: 2.4375rem;
  transition: transform 0.1s ease-in-out;

  color: black;
}

@media (min-width: 768px) {
  .hide-picker {
    width: 4.7rem;
    margin-left: -1rem;
  }

  .end-pin-button {
    width: 3.97rem;
    margin-right: 2rem;
    margin-top: -0.5rem;
  }

  .pin-button {
    width: 5.75rem;
  }
}

.pin-slider-container {
  overflow-y: revert;
  overflow-x: clip;
  margin-right: -0.5rem;
}
</style>
